import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { TM_NOTIFICATION_DOCUMENTS } from '../../../../../../../utility/SourceAPI'

const config = {
    headers: {
        'Content-Type': 'multipart/form-data;boundary=boundary'
    }
}

export const getTMNotificationDocs = createAsyncThunk('appTMNotificationDocs/getTMNotificationDocs', async (notificationId) => {
    const response = await axios.get(TM_NOTIFICATION_DOCUMENTS.concat(`?tm_notification_id=${notificationId}`))
    return response.data
})

export const createTMNotificationDoc = createAsyncThunk('appTMNotificationDocs/createTMNotificationDoc', async (payload) => {
    const response = await axios.post(TM_NOTIFICATION_DOCUMENTS, payload, config)
    return response.data
})

export const replaceTMNotificationDoc = createAsyncThunk('appTMNotificationDocs/replaceTMNotificationDoc', async (payload) => {
    const response = await axios.put(TM_NOTIFICATION_DOCUMENTS.concat(`${payload.docId}`), payload.formData, config)
    return response.data
})

export const tmNotificationDocsSlice = createSlice({
    name: 'appTMNotificationDocs',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTMNotificationDocs.fulfilled, (state, action) => {
            state.data = action.payload
        })
    }
})

export default tmNotificationDocsSlice.reducer